import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createTextVNode as _createTextVNode, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "header" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("h4", null, "Edit member details", -1)
const _hoisted_3 = { class: "modal__content" }
const _hoisted_4 = { class: "input_field" }
const _hoisted_5 = /*#__PURE__*/_createElementVNode("label", null, "Member Name", -1)
const _hoisted_6 = { class: "input_field" }
const _hoisted_7 = /*#__PURE__*/_createElementVNode("label", null, "Email Address Name", -1)
const _hoisted_8 = { class: "input_field" }
const _hoisted_9 = /*#__PURE__*/_createElementVNode("label", null, "Role", -1)
const _hoisted_10 = { class: "input_field" }
const _hoisted_11 = /*#__PURE__*/_createElementVNode("label", null, "Tags", -1)
const _hoisted_12 = { class: "modal__footer" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_v_text_field = _resolveComponent("v-text-field")!
  const _component_v_select = _resolveComponent("v-select")!
  const _component_v_checkbox_btn = _resolveComponent("v-checkbox-btn")!
  const _component_v_list_item = _resolveComponent("v-list-item")!
  const _component_v_divider = _resolveComponent("v-divider")!
  const _component_v_form = _resolveComponent("v-form")!
  const _component_CommonDialog = _resolveComponent("CommonDialog")!

  return (_openBlock(), _createBlock(_component_CommonDialog, {
    isShowHeader: false,
    isShowBackButton: false,
    className: ['edit_team_member_dialog'],
    width: "570px"
  }, {
    body: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _hoisted_2,
        _createVNode(_component_v_btn, {
          icon: "mdi-close",
          onClick: $setup.onClickCloseButton,
          variant: "plain"
        }, null, 8, ["onClick"])
      ]),
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", null, [
          _createVNode(_component_v_form, { ref: "updateMemberFormRef" }, {
            default: _withCtx(() => [
              _createElementVNode("div", _hoisted_4, [
                _hoisted_5,
                _createVNode(_component_v_text_field, {
                  type: "text",
                  density: "compact",
                  modelValue: $setup.members.name,
                  "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => (($setup.members.name) = $event)),
                  rules: $setup.validation.name,
                  variant: "outlined",
                  class: "c-input",
                  placeholder: "Member Name"
                }, null, 8, ["modelValue", "rules"])
              ]),
              _createElementVNode("div", _hoisted_6, [
                _hoisted_7,
                _createVNode(_component_v_text_field, {
                  type: "email",
                  density: "compact",
                  modelValue: $setup.members.email,
                  "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (($setup.members.email) = $event)),
                  rules: $setup.validation.email,
                  variant: "outlined",
                  class: "c-input",
                  placeholder: "Email address",
                  disabled: ""
                }, null, 8, ["modelValue", "rules"])
              ]),
              _createElementVNode("div", _hoisted_8, [
                _hoisted_9,
                _createVNode(_component_v_select, {
                  placeholder: "Select",
                  class: "c-select",
                  modelValue: $setup.members.role,
                  "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => (($setup.members.role) = $event)),
                  rules: $setup.validation.role,
                  items: ['Admin', 'Editor', 'Viewer'],
                  variant: "outlined"
                }, null, 8, ["modelValue", "rules"])
              ]),
              _createElementVNode("div", _hoisted_10, [
                _hoisted_11,
                _createVNode(_component_v_select, {
                  modelValue: $setup.selectedTags,
                  "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => (($setup.selectedTags) = $event)),
                  items: $setup.Tags,
                  placeholder: "Select Tags",
                  multiple: "",
                  variant: "outlined",
                  "menu-props": { contentClass: 'tags_dropdown' }
                }, {
                  "prepend-item": _withCtx(() => [
                    _createVNode(_component_v_list_item, {
                      title: "Select All",
                      onClick: $setup.toggle
                    }, {
                      prepend: _withCtx(() => [
                        _createVNode(_component_v_checkbox_btn, {
                          color: $setup.likesSomeTag ? 'indigo-darken-4' : undefined,
                          indeterminate: $setup.likesSomeTag && !$setup.likesAllTags,
                          "model-value": $setup.likesAllTags
                        }, null, 8, ["color", "indeterminate", "model-value"])
                      ]),
                      _: 1
                    }, 8, ["onClick"]),
                    _createVNode(_component_v_divider, { class: "mt-2" })
                  ]),
                  "append-item": _withCtx(() => [
                    _createVNode(_component_v_divider, { class: "mb-2" }),
                    _createVNode(_component_v_list_item, null, {
                      default: _withCtx(() => [
                        _createVNode(_component_v_text_field, {
                          modelValue: $setup.customTag,
                          "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => (($setup.customTag) = $event)),
                          placeholder: "Add custom tag",
                          variant: "outlined"
                        }, null, 8, ["modelValue"]),
                        _createVNode(_component_v_btn, {
                          class: "button button-orange",
                          onClick: $setup.addCustomTag
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode("Add")
                          ]),
                          _: 1
                        }, 8, ["onClick"])
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }, 8, ["modelValue", "items"])
              ])
            ]),
            _: 1
          }, 512)
        ])
      ]),
      _createElementVNode("div", _hoisted_12, [
        _createVNode(_component_v_btn, {
          class: "button button-orange",
          disabled: !$setup.isFormValid,
          onClick: $setup.onClickUpdateDetails
        }, {
          default: _withCtx(() => [
            _createTextVNode("Save Details")
          ]),
          _: 1
        }, 8, ["disabled", "onClick"])
      ])
    ]),
    _: 1
  }))
}